import { useEffect, useRef, useState } from "react";
import { Wrapper } from "./style";

// Components
import Container from "components/common/Layout/Container";
import Image from "next/image";
import Text from "components/common/Text";
import Carousel from "components/common/Carousel";
import MockupItem from "./MockupItem";
import TabBar from "components/common/TabBar";
import FAQ from "components/common/FAQ";
import Button from "components/common/Button";

// Libs
import Translation from "libs/Translation";
import Util from "libs/Util";
import { appConfig } from "configs";

const AppLanding = ({ webConfig }) => {
  const ref = useRef();
  const [directLink, setDirectLink] = useState();
  const [select, setSelect] = useState(0);

  const enPoints = [
    {
      _id: 0,
      question: `<p>${Translation.t("title.point1")}</p>`,
      answer: `<p>${Translation.t("text.point1")}</p>`,
    },
    {
      _id: 1,
      question: `<p>${Translation.t("title.point2")}</p>`,
      answer: `<p>${Translation.t("text.point2")}</p>`,
    },
    {
      _id: 2,
      question: `<p>${Translation.t("title.point3")}</p>`,
      answer: `<p>${Translation.t("text.point3")}</p>`,
    },
    {
      _id: 3,
      question: `<p>${Translation.t("title.point4")}</p>`,
      answer: `<p>${Translation.t("text.point4")}</p>`,
    },
    {
      _id: 4,
      question: `<p>${Translation.t("title.point5")}</p>`,
      answer: `<p>${Translation.t("text.point5")}</p>`,
    },
  ];
  const faPoints = [
    {
      _id: 0,
      question: `<p>${Translation.t("title.point1")}</p>`,
      answer: `<p>${Translation.t("text.point1")}</p>`,
    },
    {
      _id: 1,
      question: `<p>${Translation.t("title.point2")}</p>`,
      answer: `<p>${Translation.t("text.point2")}</p>`,
    },
    {
      _id: 2,
      question: `<p>${Translation.t("title.point3")}</p>`,
      answer: `<p>${Translation.t("text.point3")}</p>`,
    },
    {
      _id: 3,
      question: `<p>${Translation.t("title.point4")}</p>`,
      answer: `<p>${Translation.t("text.point4")}</p>`,
    },
  ];
  const [points, setPoints] = useState(faPoints);

  const androidApps = [
    {
      id: 0,
      icon: "/nextasset/images/landing/play.png",
      label: Translation.t("label.google-play"),
      link: "https://dm.vclinic.io/z26",
    },
    {
      id: 2,
      icon: "/nextasset/images/landing/bazaar.svg",
      label: Translation.t("label.bazaar"),
      link: "https://dm.vclinic.io/et3",
    },
    {
      id: 1,
      icon: "/nextasset/images/landing/android.png",
      label: Translation.t("label.direct"),
      link: directLink,
    },
  ];

  const tabs = [
    { id: 0, name: Translation.t("title.android-app"), data: androidApps },
    // {id: 1, name: Translation.t('label.direct')},
  ];

  const enMockups = [
    { id: 0, img: "/nextasset/images/landing/mockup1.jpeg" },
    { id: 1, img: "/nextasset/images/landing/mockup2.jpeg" },
    { id: 2, img: "/nextasset/images/landing/mockup3.jpeg" },
    { id: 3, img: "/nextasset/images/landing/mockup4.jpeg" },
  ];
  const faMockups = [
    { id: 0, img: "/nextasset/images/landing/mockup1-fa.jpeg" },
    { id: 1, img: "/nextasset/images/landing/mockup2-fa.jpeg" },
    { id: 2, img: "/nextasset/images/landing/mockup3-fa.jpeg" },
    { id: 3, img: "/nextasset/images/landing/mockup4-fa.jpeg" },
  ];
  const [mockups, setMockups] = useState([]);

  useEffect(() => {
    webConfig.lang === "fa"
      ? setPoints(faPoints)
      : webConfig.lang === "en"
      ? setPoints(enPoints)
      : null;
    webConfig.lang === "fa" ? setMockups(faMockups) : setMockups(enMockups);
  }, [webConfig]);

  // Connect to minio
  useEffect(() => {
    let fileName;
    appConfig.uat === true
      ? (fileName = "build/app/outputs/flutter-apk/app-release-stage-arm64.apk")
      : (fileName = "build/app/outputs/flutter-apk/app-release-prod.apk");
    Util.connectToMinio("mobile", fileName, setDirectLink);
  }, []);

  const handleChange = (n) => {
    setSelect(n);
  };

  const handleGoToDownloadBox = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Wrapper webConfig={webConfig}>
      <div className="header">
        <Container>
          <div className="header-content">
            <Text tag="h2">{Translation.t("text.header-app-desc")}</Text>
            <Button onClick={handleGoToDownloadBox} className="button">
              {Translation.t("text.download-vclinic-app")}
            </Button>
          </div>
        </Container>
      </div>
      <Container>
        <div className="column-flex" ref={ref}>
          <Text className="main-title" tag="span">
            {Translation.t("title.download-vclinic-app")}
          </Text>
          <Text className="desc" tag="h2">
            {Translation.t("text.download-app-desc")}
          </Text>
          <div className="download-box">
            <TabBar
              list={tabs}
              select={select}
              handleChange={handleChange}
              itemsCount={tabs.length}
              spaceBetweenItems={true}
            >
              <div className="column-flex dl-items">
                {tabs[select].data.map((a) => (
                  <a
                    key={a.id}
                    href={a.link}
                    className="dl-item"
                    download={true}
                  >
                    <Image
                      src={a.icon}
                      width={18}
                      height={18}
                      alt={`${a.label} icon`}
                    />
                    {a.label}
                  </a>
                ))}
              </div>
            </TabBar>
          </div>
        </div>
        <div className="carousel">
          <Carousel
            id="mockup"
            arrow={false}
            items={mockups}
            autoplay={true}
            gap={0}
            renderItem={(item) => <MockupItem {...item} />}
          />
        </div>
        <div className="text-content">
          <Text tag="span" className="feature-title">
            {Translation.t("title.app-features")}
          </Text>
          <FAQ faq={points} />
        </div>
      </Container>
    </Wrapper>
  );
};

export default AppLanding;
